import {
  Button,
  createTheme,
  CSSVariablesResolver,
  Loader,
  LoadingOverlay,
  MantineProvider,
  Modal,
  Select,
} from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import React from 'react';

import AirbrakeErrorBoundary from './AirbrakeBoundary';
import ApolloClientProvider, { ApolloClientProviderProps } from './ApolloClientProvider';
import CaptchaProvider from './CaptchaProvider';
import { SHARED_COLORS } from './theme-colors';

export type ThemeProviderProps = ApolloClientProviderProps;

const CateringProvider: React.FC<ThemeProviderProps> = ({ children, clientOptions }) => (
  <AirbrakeErrorBoundary>
    <ApolloClientProvider clientOptions={clientOptions}>
      <MantineProvider theme={theme} cssVariablesResolver={resolver} defaultColorScheme="light">
        <ModalsProvider>
          <Notifications position="bottom-right" autoClose={2000} zIndex={5010} />
          <CaptchaProvider>{children}</CaptchaProvider>
        </ModalsProvider>
      </MantineProvider>
    </ApolloClientProvider>
  </AirbrakeErrorBoundary>
);

export default CateringProvider;

const theme = createTheme({
  fontSmoothing: false,
  fontFamily: '"Lato", sans-serif;',
  cursorType: 'pointer',
  components: {
    Modal: Modal.extend({
      defaultProps: {
        overlayProps: { backgroundOpacity: 0.55, blur: 3 },
        transitionProps: { duration: 300 },
        zIndex: 5000,
      },
    }),
    Select: Select.extend({
      defaultProps: {
        comboboxProps: { zIndex: 5100 },
      },
    }),
    Loader: Loader.extend({
      defaultProps: {
        type: 'dots',
        color: 'orange',
      },
    }),
    LoadingOverlay: LoadingOverlay.extend({
      defaultProps: {
        overlayProps: { blur: 2 },
        loaderProps: { type: 'dots' },
      },
    }),
    Button: Button.extend({
      defaultProps: {
        loaderProps: { type: 'dots' },
      },
    }),
  },
  colors: SHARED_COLORS,
});

const resolver: CSSVariablesResolver = (theme) => ({
  variables: {
    '--snappea-color-body': '#FFFFFF',
    '--snappea-color-text': '#333333',
    '--snappea-font-size-text': theme.fontSizes.sm,
  },
  light: {},
  dark: {},
});
